import React, { FC } from 'react'
import { StyledIcon, StyledIconProps } from './styled-icon'

export const CsDropdownCollapseIcon: FC<StyledIconProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M826.2 654.6l-3.6-4.2-272-313c-9.2-10.6-23-17.2-38.4-17.2s-29.2 6.8-38.4 17.2L197.4 655c-3.4 5-5.4 11-5.4 17.4 0 17.4 14.8 31.6 33.2 31.6h573.6c18.4 0 33.2-14.2 33.2-31.6 0-6.6-2.2-12.8-5.8-17.8z" />
    </g>
  </StyledIcon>
)

CsDropdownCollapseIcon.displayName = 'CsDropdownCollapseIcon'
